export const ACCESS_TOKEN_SECRET = "t2qckOEgV88Gp";

export const STRIPE_PUBLIC_KEY =
  "pk_test_51NB5kmESRkXH2UX1JrpDa0ONFkxsIJaloM3hkOuM5CMXTHhYCCD0mQqmXGj9FMbgC19iKC7r8OgE5ijlIl7WEQGa00MoaYd7ta";

export const CURRENCY_SYMBOL = "BHD";

export var RECORDS_LIMIT = 10;
export var RECORDS_LIMIT50 = 50;
